// src/components/CategoryExperience.js
import React from 'react';
import './CategoryExperience.css';


const CategoryExperience = () => {
    return (
        <section className="practice-section">
            <div className="practice-container">
                <h5 className="practice-subheading">WHY Doclivo?</h5>
                <h2 className="practice-main-heading">A Coherent, Connected Practice</h2>

                <div className="practice-columns">
                    <div className="practice-column">
                        <div className="practice-icon">1</div>
                        <h3 className="practice-column-heading">
                            A Comprehensive, Unified Platform for All Your Practice Needs
                        </h3>
                        <p>
                            Gain new patients through robust marketing automation, improve care delivery with a cloud-based certified EHR, enhance the patient experience using automated communication tools, and expedite payments with billing and payment solutions.
                        </p>
                    </div>

                    <div className="practice-column">
                        <div className="practice-icon">2</div>
                        <h3 className="practice-column-heading">
                            Effortless Implementation of Automated End-to-End Workflows
                        </h3>
                        <p>
                            Intelligent automation rapidly streamlines processes, from reaching patients to post-appointment workflows. This liberates staff, allowing them to dedicate more time to tasks that enhance your practice's success, and less time on inefficient, manual activities.
                        </p>
                    </div>

                    <div className="practice-column">
                        <div className="practice-icon">3</div>
                        <h3 className="practice-column-heading">
                            Enhanced Business Insights for Accelerated Strategic Growth
                        </h3>
                        <p>
                            Integrating our analytics into your daily workflow enables you to unearth revenue, SEO, reputation management, and website insights that will have the most significant impact on your business.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CategoryExperience;
